import i18n from '@i18next/i18n';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { EEffectAlgn } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { ITextRunStyle } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-styles.interface';
import { CompoundType, GradientType } from '@tencent/alloy-renderer-adapter';
import { STSchemeColorVal } from '@tencent/slide-sdk-model';

export interface ITextFastStyleConfig {
    title: string;
    style: ITextRunStyle;
}

export const TextFastStyleConfigs: ITextFastStyleConfig[] = [
    {
        title: `${i18n.t('填充')}：${i18n.t('文本色{0}', { 0: 1 })}，${i18n.t('阴影')}`,
        style: {
            border: { width: 0 },
            effect: {
                shadow: {
                    algn: EEffectAlgn.TL,
                    blurRad: 3,
                    tdColor: new TDColor({ rgbaStr: '#000000' }),
                    color: '#000000',
                    dir: 45,
                    dist: 1.5,
                    isOuter: true,
                    opacity: 60,
                    rotWithShape: 0,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
            tdColor: new TDColor({ themeKey: STSchemeColorVal.tx1 }),
        },
    },
    {
        title: `${i18n.t('填充')}：${i18n.t('主题色{0}', { 0: 1 })}，${i18n.t('阴影')}`,
        style: {
            border: { width: 0 },
            effect: {
                shadow: {
                    algn: EEffectAlgn.CTR,
                    blurRad: 3,
                    tdColor: new TDColor({ rgbaStr: '#6E747A' }),
                    color: '#6E747A',
                    dir: 90,
                    dist: 2,
                    isOuter: true,
                    opacity: 57,
                    rotWithShape: 0,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
            tdColor: new TDColor({ themeKey: STSchemeColorVal.accent1 }),
        },
    },
    {
        title: `${i18n.t('填充')}：${i18n.t('主题色{0}', { 0: 2 })}，${i18n.t('边框')}：${i18n.t('主题色{0}', {
            0: 2,
        })}`,
        style: {
            border: {
                style: 'solid',
                tdColor: new TDColor({ themeKey: STSchemeColorVal.accent2 }),
                width: 3.5,
            },
            tdColor: new TDColor({ themeKey: STSchemeColorVal.accent2, lumMod: 40000, lumOff: 60000 }),
        },
    },
    {
        title: `${i18n.t('填充')}：${i18n.t('白色')}，${i18n.t('边框')}：${i18n.t('主题色{0}', { 0: 5 })}，${i18n.t('阴影')}`,
        style: {
            border: {
                style: 'solid',
                tdColor: new TDColor({ themeKey: STSchemeColorVal.accent5 }),
                width: 1.6,
            },
            effect: {
                shadow: {
                    algn: EEffectAlgn.TL,
                    blurRad: 3,
                    tdColor: new TDColor({ rgbaStr: '#000000' }),
                    color: '#000000',
                    dir: 90,
                    dist: 1.8,
                    isOuter: true,
                    opacity: 70,
                    rotWithShape: 0,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
            tdColor: new TDColor({ rgbaStr: '#FFFFFF' }),
        },
    },
    {
        title: `${i18n.t('渐变填充')}：${i18n.t('灰色')}`,
        style: {
            border: {
                width: 0,
            },
            gradFill: {
                gsList: [
                    { pos: 21, color: new TDColor({ rgbaStr: '#53575C' }) },
                    { pos: 88, color: new TDColor({ rgbaStr: '#c5c7ca' }) },
                ],
                lin: {
                    ang: 90,
                    scaled: 0,
                },
                pathGradient: {
                    path: GradientType.Linear,
                },
            },
        },
    },
    {
        title: `${i18n.t('渐变填充')}：${i18n.t('主题色{0}', { 0: 5 })}，${i18n.t('映像')}`,
        style: {
            border: {
                width: 0,
            },
            gradFill: {
                gsList: [
                    { pos: 0, color: new TDColor({ themeKey: STSchemeColorVal.accent5, lumMod: 50000 }) },
                    { pos: 50, color: new TDColor({ themeKey: STSchemeColorVal.accent5 }) },
                    {
                        pos: 100,
                        color: new TDColor({ themeKey: STSchemeColorVal.accent5, lumMod: 60000, lumOff: 40000 }),
                    },
                ],
                lin: {
                    ang: 90,
                    scaled: 0,
                },
                pathGradient: {
                    path: GradientType.Linear,
                },
            },
            effect: {
                reflection: {
                    blurRad: 7,
                    dir: 90,
                    dist: 0,
                    startOpacity: 9,
                    endOpacity: 100,
                    size: 100,
                    sy: -1,
                    rotWithShape: 0,
                },
            },
        },
    },
    {
        title: `${i18n.t('渐变填充')}：${i18n.t('主题色{0}', { 0: 4 })}，${i18n.t('边框')}：${i18n.t('主题色{0}', {
            0: 4,
        })}`,
        style: {
            border: {
                style: 'solid',
                tdColor: new TDColor({ themeKey: STSchemeColorVal.accent4 }),
                width: 2,
                compoundType: CompoundType.SINGLE,
            },
            gradFill: {
                gsList: [
                    { pos: 0, color: new TDColor({ themeKey: STSchemeColorVal.accent4, lumMod: 50000 }) },
                    {
                        pos: 4,
                        color: new TDColor({ themeKey: STSchemeColorVal.accent4, lumMod: 60000, lumOff: 40000 }),
                    },
                    {
                        pos: 87,
                        color: new TDColor({ themeKey: STSchemeColorVal.accent4, lumMod: 20000, lumOff: 80000 }),
                    },
                ],
                lin: {
                    ang: 90,
                    scaled: 0,
                },
                pathGradient: {
                    path: GradientType.Linear,
                },
            },
        },
    },
    {
        title: `${i18n.t('填充')}：${i18n.t('白色')}，${i18n.t('边框')}：${i18n.t('主题色{0}', { 0: 1 })}，${i18n.t('发光')}：${i18n.t('主题色{0}', {
            0: 1,
        })}`,
        style: {
            border: {
                style: 'solid',
                tdColor: new TDColor({ themeKey: STSchemeColorVal.accent1 }),
                width: 1.5,
                compoundType: CompoundType.SINGLE,
            },
            effect: {
                glow: {
                    opacity: 60,
                    size: 3,
                    tdColor: new TDColor({ themeKey: STSchemeColorVal.accent1 }),
                    color: '',
                },
            },
        },
    },
    {
        title: `${i18n.t('填充')}：${i18n.t('文本色{0}', { 0: 1 })}，${i18n.t('边框')}：${i18n.t('背景色{0}', {
            0: 1,
        })}，${i18n.t('清晰阴影')}：${i18n.t('背景色{0}', {
            0: 1,
        })}`,
        style: {
            border: {
                style: 'solid',
                tdColor: new TDColor({ themeKey: STSchemeColorVal.bg1 }),
                width: 1.5,
            },
            effect: {
                shadow: {
                    algn: EEffectAlgn.TL,
                    blurRad: 1,
                    tdColor: new TDColor({ themeKey: STSchemeColorVal.bg1, lumMod: 50000 }),
                    color: '',
                    dir: 45,
                    dist: 3,
                    isOuter: true,
                    opacity: 0,
                    rotWithShape: 0,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
            tdColor: new TDColor({ themeKey: STSchemeColorVal.tx1 }),
        },
    },
    {
        title: `${i18n.t('填充')}：${i18n.t('文本色{0}', { 0: 1 })}，${i18n.t('边框')}：${i18n.t('背景色{0}', {
            0: 1,
        })}，${i18n.t('清晰阴影')}：${i18n.t('主题色{0}', {
            0: 5,
        })}`,
        style: {
            border: {
                style: 'solid',
                tdColor: new TDColor({ themeKey: STSchemeColorVal.bg1 }),
                width: 2.12,
            },
            effect: {
                shadow: {
                    algn: EEffectAlgn.BL,
                    blurRad: 0,
                    tdColor: new TDColor({ themeKey: STSchemeColorVal.accent5 }),
                    color: '',
                    dir: 45,
                    dist: 3,
                    isOuter: true,
                    opacity: 0,
                    rotWithShape: 0,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
            tdColor: new TDColor({ themeKey: STSchemeColorVal.tx1, lumMod: 85000, lumOff: 15000 }),
        },
    },
    {
        title: `${i18n.t('填充')}：${i18n.t('主题色{0}', { 0: 5 })}，${i18n.t('边框')}：${i18n.t('背景色{0}', {
            0: 1,
        })}，${i18n.t('清晰阴影')}：${i18n.t('主题色{0}', {
            0: 5,
        })}`,
        style: {
            border: {
                style: 'solid',
                tdColor: new TDColor({ themeKey: STSchemeColorVal.bg1 }),
                width: 1.5,
            },
            effect: {
                shadow: {
                    algn: EEffectAlgn.TL,
                    blurRad: 1,
                    tdColor: new TDColor({ themeKey: STSchemeColorVal.accent5, lumMod: 60000, lumOff: 40000 }),
                    color: '',
                    dir: 45,
                    dist: 3,
                    isOuter: true,
                    opacity: 0,
                    rotWithShape: 0,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
            tdColor: new TDColor({ themeKey: STSchemeColorVal.accent5 }),
        },
    },
    {
        title: `${i18n.t('填充')}：${i18n.t('白色')}，${i18n.t('边框')}：${i18n.t('主题色{0}', {
            0: 2,
        })}，${i18n.t('清晰阴影')}：${i18n.t('主题色{0}', {
            0: 2,
        })}`,
        style: {
            border: {
                style: 'solid',
                tdColor: new TDColor({ themeKey: STSchemeColorVal.accent2 }),
                width: 1,
            },
            effect: {
                shadow: {
                    algn: EEffectAlgn.TL,
                    blurRad: 0,
                    tdColor: new TDColor({ themeKey: STSchemeColorVal.accent2 }),
                    color: '',
                    dir: 45,
                    dist: 3,
                    isOuter: true,
                    opacity: 0,
                    rotWithShape: 0,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
            tdColor: new TDColor({ rgbaStr: '#FFFFFF' }),
        },
    },
    {
        title: `${i18n.t('填充')}：${i18n.t('背景色{0}', { 0: 2 })}，${i18n.t('内部阴影')}`,
        style: {
            border: {
                width: 0,
            },
            effect: {
                shadow: {
                    blurRad: 5,
                    tdColor: new TDColor({ rgbaStr: '#000000', alpha: 0.5 }),
                    color: '',
                    dir: 225,
                    dist: 4,
                    isOuter: false,
                    opacity: 50,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
            tdColor: new TDColor({ themeKey: STSchemeColorVal.bg2 }),
        },
    },
    {
        title: `${i18n.t('图案填充')}：${i18n.t('白色')}，${i18n.t('深色上对角线')}，${i18n.t('阴影')}`,
        style: {
            border: {
            },
            effect: {
                shadow: {
                    algn: EEffectAlgn.TL,
                    blurRad: 3,
                    tdColor: new TDColor({ themeKey: STSchemeColorVal.dk1, alpha: 0.4, lumMod: 50000 }),
                    color: '',
                    dir: 45,
                    dist: 1.5,
                    isOuter: true,
                    opacity: 60,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
            pattFill: {
                bgColor: {
                    color: new TDColor({
                        alpha: 1,
                        themeKey: STSchemeColorVal.tx1,
                        lumMod: 75000,
                        lumOff: 25000,
                    }),
                },
                fgColor: {
                    color: new TDColor({
                        alpha: 1,
                        themeKey: STSchemeColorVal.bg1,
                        lumMod: 50000,
                    }),
                },
                preset: 'dkUpDiag',
            },
        },
    },
    {
        title: `${i18n.t('图案填充')}：${i18n.t('主题色{0}', { 0: 3 })}，${i18n.t('窄横线')}，${i18n.t('内部阴影')}`,
        style: {
            border: {
                style: 'solid',
                tdColor: new TDColor({ themeKey: STSchemeColorVal.accent3, lumMod: 50000 }),
                width: 2,
            },
            effect: {
                shadow: {
                    blurRad: 14,
                    tdColor: new TDColor({ themeKey: STSchemeColorVal.dk1, alpha: 0.4, lumMod: 50000 }),
                    color: '',
                    dir: 0,
                    dist: 0,
                    isOuter: false,
                    opacity: 0,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
            pattFill: {
                bgColor: {
                    color: new TDColor({
                        alpha: 1,
                        themeKey: STSchemeColorVal.accent3,
                        lumMod: 40000,
                        lumOff: 60000,
                    }),
                },
                fgColor: {
                    color: new TDColor({
                        alpha: 1,
                        themeKey: STSchemeColorVal.accent3,
                    }),
                },
                preset: 'narHorz',
            },
        },
    },
    {
        title: `${i18n.t('图案填充')}：${i18n.t('主题色{0}', { 0: 1 })}，50%；${i18n.t('清晰阴影')}，${i18n.t(
            '主题色{0}',
            { 0: 1 },
        )}`,
        style: {
            border: {
                style: 'solid',
                tdColor: new TDColor({ themeKey: STSchemeColorVal.accent1 }),
                width: 2,
            },
            effect: {
                shadow: {
                    algn: EEffectAlgn.BL,
                    blurRad: 0,
                    tdColor: new TDColor({ themeKey: STSchemeColorVal.accent1 }),
                    color: '',
                    dir: 44,
                    dist: 3,
                    isOuter: true,
                    opacity: 0,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
            pattFill: {
                bgColor: {
                    color: new TDColor({
                        themeKey: STSchemeColorVal.accent1,
                        lumMod: 20000,
                        lumOff: 80000,
                    }),
                },
                fgColor: {
                    color: new TDColor({
                        alpha: 1,
                        themeKey: STSchemeColorVal.accent1,
                    }),
                },
                preset: 'pct50',
            },
        },
    },
    {
        title: `${i18n.t('图案填充')}：${i18n.t('主题色{0}', { 0: 5 })}，50%；${i18n.t('浅色下对角线')}；${i18n.t('边框')}：${i18n.t('主题色{0}', { 0: 5 })}`,
        style: {
            border: {
                style: 'solid',
                tdColor: new TDColor({ themeKey: STSchemeColorVal.accent5 }),
                width: 2,
            },
            pattFill: {
                bgColor: {
                    color: new TDColor({
                        alpha: 1,
                        themeKey: STSchemeColorVal.bg1,
                    }),
                },
                fgColor: {
                    color: new TDColor({
                        alpha: 1,
                        themeKey: STSchemeColorVal.accent5,
                        lumMod: 60000,
                        lumOff: 40000,
                    }),
                },
                preset: 'ltDnDiag',
            },
        },
    },
    {
        title: `${i18n.t('图案填充')}：${i18n.t('深蓝')}，${i18n.t('深色上对角线')}；${i18n.t('清晰阴影')}`,
        style: {
            border: {
                style: 'solid',
                tdColor: new TDColor({ themeKey: STSchemeColorVal.tx2, lumMod: 75000 }),
                width: 2,
            },
            effect: {
                shadow: {
                    algn: EEffectAlgn.BL,
                    blurRad: 0,
                    tdColor: new TDColor({ themeKey: STSchemeColorVal.tx2, lumMod: 75000 }),
                    color: '',
                    dir: 44,
                    dist: 3,
                    isOuter: true,
                    opacity: 0,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
            pattFill: {
                bgColor: {
                    color: new TDColor({
                        alpha: 1,
                        themeKey: STSchemeColorVal.tx2,
                        lumMod: 20000,
                        lumOff: 80000,
                    }),
                },
                fgColor: {
                    color: new TDColor({
                        alpha: 1,
                        themeKey: STSchemeColorVal.tx2,
                    }),
                },
                preset: 'dkUpDiag',
            },
        },
    },
];
